import Vue from 'vue'
import VueMatomo from 'vue-matomo'
import router from '../router'

let host = ''
let siteId = ''

if (process.env.NODE_ENV == 'development') {
    host = process.env.VUE_APP_DEV_ANALYTIC_URL
    siteId = process.env.VUE_APP_DEV_ANALYTIC_SITE_ID
} else {
    host = process.env.VUE_APP_PROD_ANALYTIC_URL
    siteId = process.env.VUE_APP_PROD_ANALYTIC_SITE_ID
}

Vue.use(VueMatomo, {
    host,
    siteId,
    router: router,
    enableHeartBeatTimer: true,
    debug: process.env.NODE_ENV == 'development',
})
